/* eslint-env es6 */
/* eslint-disable */
import Swiper from 'swiper/dist/js/swiper.js'

var swiper = new Swiper('.swiper-container', {
  slidesPerView: 5,
  spaceBetween: 60,
  loop: true,
  autoplay: {
    delay: 3000,
  },
  breakpoints: {
    1024: {
      slidesPerView: 5,
    },
    768: {
      slidesPerView: 4,
      spaceBetween: 48,
    },
    640: {
      slidesPerView: 2,
      spaceBetween: 32,
    },
    320: {
      slidesPerView: 1,
    }
  }
});

var swiperQuotes = new Swiper('.swiper-container-quotes', {
  direction: 'horizontal',
  slidesPerView: 1,
  spaceBetween: 0,
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next-quotes',
    prevEl: '.swiper-button-prev-quotes',
  },
  pagination: {
    el: '.swiper-pagination-quotes',
  },
});

var swiperSpaces = new Swiper('.swiper-container-spaces', {
  direction: 'horizontal',
  slidesPerView: 1,
  spaceBetween: 0,
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next-spaces',
    prevEl: '.swiper-button-prev-spaces',
  },
  pagination: {
    el: '.swiper-pagination-spaces',
  },
});



// WEBPACK FOOTER //
// ./resources/assets/js/swiper-sliders.js